// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"bcfa3871b07f9445876f","913":"d596ddaf4f9c7f7b0ccb"}[chunkId] + ".js";
};